import { Wave } from 'better-react-spinkit'
import { equalTo, onValue, orderByChild, query, ref, serverTimestamp, set } from 'firebase/database'
import React, { useContext, useEffect, useRef, useState } from 'react'
import { BsPlusLg } from 'react-icons/bs'
import { MdClose } from 'react-icons/md'
import { toast, ToastContainer } from 'react-toastify'
import { AuthContext } from '../../authContext/AuthContext'
import { database } from '../../firebase'
import Navbar from '../navbar/Navbar'
import Sidebar from '../sidebar/Sidebar'
import MachineItem from './MachineItem'
import { AiOutlineReload } from 'react-icons/ai'

const Machines = () => {
    const { currentUser } = useContext(AuthContext)
    const [showModal, setShowModal] = useState(false)
    const [isLoading, setIsLoading] = useState(false)
    const [machines, setMachines] = useState([])
    const [filteredMachines, setFilteredMachines] = useState([])
    const [fetchLoading, setFetchLoading] = useState(false)
    const [machineType, setMachineType] = useState(null)
    const fetchMachines = useRef(() => {
        setFetchLoading(true)
        const q = query(ref(database, `admins`), orderByChild("adminId"), equalTo(currentUser.uid))

        onValue(q, (snapshot) => {
            let data = []
            snapshot.forEach((childsnapshot) => {
                data.push(childsnapshot.val())
            })
            setMachines(data)
            setFilteredMachines(data)
            setFetchLoading(false)
        })
    })

    useEffect(() => {
        fetchMachines.current()
    }, [currentUser.uid])

    const handleSubmit = (e) => {
        e.preventDefault()
        setIsLoading(true)
        const form = e.target
        if (form.checkValidity()) {
            const formData = new FormData(form)
            const formValues = Array.from(formData.keys()).reduce((acc, key) => {
                acc[key] = form.elements[key].value
                return acc
            }, {})

            try {
                onValue(ref(database, 'admins/' + formValues.macAddress), (snapshot) => {
                    if (snapshot.exists()) {
                        toast.error('This mac address is already taken.')
                    } else {
                        set(ref(database, 'admins/' + formValues.macAddress), {
                            ...formValues,
                            timestamp: serverTimestamp(),
                            adminId: currentUser.uid,
                            total: 0,
                            D5: "1",
                            D7: "1"
                        });
                        toast.success("Machine added.")
                        form.reset()
                    }
                }, {
                    onlyOnce: true
                });
                setIsLoading(false)
                setMachineType(null)
            } catch (e) {
                toast.error(e.message)
                setIsLoading(false)
            }
        } else {
            const formData = new FormData(form)
            const validationMessages = Array.from(formData.keys()).reduce((acc, key) => {
                acc[key] = form.elements[key].validationMessage
                return acc
            }, {})
            setIsLoading(false)
            if (machineType === 'Plotter') {
                toast.error(
                    validationMessages.macAddress !== '' ?
                        'Mac Address ' + validationMessages.macAddress :
                        validationMessages.D7 !== '' ?
                            'D7 ' + validationMessages.D7 :
                            validationMessages.D5 !== '' ?
                                'D5 ' + validationMessages.D5 :
                                validationMessages.D2 !== '' ?
                                    'D2 ' + validationMessages.D2 :
                                    validationMessages.type !== '' ?
                                        'Machine Type ' + validationMessages.type : null
                )

            } else if (machineType === 'Embroidery') {
                toast.error(
                    validationMessages.macAddress !== '' ?
                        'Mac Address ' + validationMessages.macAddress :
                        validationMessages.Name !== '' ? 'Name is required' :
                            validationMessages.HeadNumber !== '' && 'Head Number is required'
                )
            }
        }
    }

    const handleTypeChange = (e) => {
        setFilteredMachines(machines.filter((m) => {
            if (e.target.value === 'all') return m
            return m.type === e.target.value
        }))
    }

    return (
        <>
            <div>
                <Navbar />
                <div className="flex bg-gray-100">
                    <Sidebar currentPage='Machines' />
                    <div className="flex-1 overflow-hidden h-[calc(100vh-50px)] flex justify-center items-center">
                        <div className="w-[98%] mx-2 bg-white rounded-lg h-[96%] shadow-md flex flex-col overflow-hidden">
                            <header className="w-full h-16 border-b-[1px] bg-gray-50 border-slate-300 flex justify-between items-center px-2 sm:px-3">
                                <h1 className='font-bold text-xl box-border text-slate-600'>Machines</h1>
                                <div className="flex space-x-3 items-center">
                                    <div>
                                        <select onChange={handleTypeChange} className='shadow bg-white px-1 sm:px-3 py-2 rounded-lg text-slate-800 outline-none'>
                                            <option value="all">All</option>
                                            <option value="Plotter">Plotter</option>
                                            <option value="Embroidery">Embroidery</option>
                                        </select>
                                    </div>
                                    <AiOutlineReload className='text-xl text-slate-700 cursor-pointer active:rotate-90 transition-rotate duration-200' onClick={() => fetchMachines.current()} />
                                    <div onClick={() => setShowModal(!showModal)} className="flex h-8 sm:h-auto justify-center btn-color shadow text-white items-center px-3 py-1 font-medium rounded-md cursor-pointer">
                                        <BsPlusLg className='text-white font-bold text-sm sm:mr-2' />
                                        <span className='hidden sm:block'>
                                            Add Machine
                                        </span>
                                    </div>
                                </div>
                            </header>
                            <div className="flex-1 overflow-auto">
                                <div className="flex flex-1 p-1 flex-wrap justify-center">
                                    {filteredMachines.map((machine, i) => (
                                        <MachineItem key={i} machine={machine} />
                                    ))}
                                </div>
                                <div className="flex my-2 items-center justify-center">
                                    {fetchLoading && <Wave color='gray' size={35} />}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {showModal ? (
                    <>
                        <div
                            className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none"
                        >
                            <div className="relative w-auto my-6 mx-auto max-w-3xl">
                                <div className="border-0 rounded-lg shadow-lg relative flex flex-col max-h-[84vh] w-[100vw] sm:w-[360px] bg-white outline-none focus:outline-none">
                                    {/*header*/}
                                    <div className="flex items-center justify-between px-3 py-4 border-b border-solid border-slate-200 rounded-t">
                                        <h3 className="text-xl font-semibold">
                                            Add Machine
                                        </h3>
                                        <MdClose className='text-2xl cursor-pointer font-bold text-black' onClick={() => setShowModal(false)} />
                                    </div>
                                    {/*body*/}
                                    <form noValidate onSubmit={handleSubmit} className="relative p-3 sm:p-2 flex-auto flex flex-col overflow-y-auto">
                                        <select name="type" required onChange={(e) => setMachineType(e.target.value)} className='border border-gray-400 shadow min-h-[45px] my-2 w-full bg-gray-100 h-12 px-3 rounded-lg text-slate-800 outline-none'>
                                            <option value="">Select Machine Type</option>
                                            <option value="Plotter">Plotter</option>
                                            <option value="Embroidery">Embroidery</option>
                                        </select>
                                        <hr />
                                        {machineType === 'Plotter' ? (
                                            <>
                                                <input name="macAddress" required minLength='10' type="text" className='border border-gray-400 shadow min-h-[45px] my-2 w-full bg-gray-100 h-12 px-3 rounded-lg text-slate-800 outline-none' placeholder='Mac Address' />
                                                <input name="Name" required type="text" className='border border-gray-400 shadow min-h-[45px] my-2 w-full bg-gray-100 h-12 px-3 rounded-lg text-slate-800 outline-none' placeholder='Name' />
                                                {/* <input name="D7" required type="text" className='border border-gray-400 shadow min-h-[45px] my-2 w-full bg-gray-100 h-12 px-3 rounded-lg text-slate-800 outline-none' placeholder='D7' /> */}
                                                {/* <input name="D5" required minLength='1' type="text" className='border border-gray-400 shadow min-h-[45px] my-2 w-full bg-gray-100 h-12 px-3 rounded-lg text-slate-800 outline-none' placeholder='D5' />
                                                <input name="D2" required minLength='1' type="text" className='border border-gray-400 shadow min-h-[45px] my-2 w-full bg-gray-100 h-12 px-3 rounded-lg text-slate-800 outline-none' placeholder='D2' /> */}
                                            </>
                                        ) : machineType === 'Embroidery' && (
                                            <>
                                                <input name="macAddress" required minLength='10' type="text" className='border border-gray-400 shadow min-h-[45px] my-2 w-full bg-gray-100 h-12 px-3 rounded-lg text-slate-800 outline-none' placeholder='Mac Address' />
                                                <input name="Name" required type="text" className='border border-gray-400 shadow min-h-[45px] my-2 w-full bg-gray-100 h-12 px-3 rounded-lg text-slate-800 outline-none' placeholder='Name' />
                                                <input name="HeadNumber" required type="number" className='border border-gray-400 shadow min-h-[45px] my-2 w-full bg-gray-100 h-12 px-3 rounded-lg text-slate-800 outline-none' placeholder='Head Number' />
                                                {/* <input name="D5" required type="text" className='border border-gray-400 shadow min-h-[45px] my-2 w-full bg-gray-100 h-12 px-3 rounded-lg text-slate-800 outline-none' placeholder='D5' /> */}
                                            </>
                                        )}
                                        <button
                                            disabled={isLoading}
                                            className="bg-emerald-500 mt-3 flex justify-center items-center text-white disabled:bg-gray-400 active:bg-emerald-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                                            type="submit"
                                        >
                                            {isLoading ? <Wave size={32} color='white' />
                                                : 'Submit Machine'}
                                        </button>

                                    </form>
                                    {/*footer*/}
                                    <div className="flex items-center justify-end py-2 px-3 border-t border-solid border-slate-200 rounded-b">
                                        <button
                                            className="modal-close-btn"
                                            type="button"
                                            onClick={() => setShowModal(false)}
                                        >
                                            Close
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
                    </>
                ) : null}
                <ToastContainer
                    position="top-right"
                    autoClose={5000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                    theme='dark'
                />
            </div>
        </>
    )
}

export default Machines